import { StatisticsApplicationsChart } from "components/Common"
import React, { useMemo } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import PropTypes from "prop-types"

const BodyMidBottom = ({ data }) => {
  const { statisticData, labelStatistic, dataLine } = useMemo(() => {
    if (!data?.density || !Array.isArray(data.density)) {
      return {
        statisticData: [],
        labelStatistic: [],
        dataLine: { data: [], type: "line" }
      }
    }

    const columnData = data.density.map(item => item.count)
    const labels = data.density.map(item => item.label)
    const lineData = data.density.map(item => parseInt(item.count, 10))

    const statistic = [
      {
        data: columnData,
        type: "column",
      },
      lineData
    ]

    return {
      statisticData: statistic,
      labelStatistic: labels,
      dataLine: {
        data: lineData,
        type: "line",
      }
    }
  }, [data])

  return (
    <Card className="mb-2" style={{ height: '200px' }}>
      <CardHeader
        style={{
          textAlign: "center",
          background: "#fff",
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 600 }}>
          Mật độ mẫu
        </div>
      </CardHeader>
      <CardBody style={{ paddingTop: 0, paddingBottom: 0 }}>
        <Row>
          <Col sm="12" style={{ padding: 0 }}>
            <StatisticsApplicationsChart
              seriesData={statisticData}
              labels={labelStatistic}
              dataLine={dataLine}
              height="145"
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

BodyMidBottom.propTypes = {
  data: PropTypes.shape({
    density: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hour: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    )
  })
}

BodyMidBottom.defaultProps = {
  data: {
    density: []
  }
}

export default BodyMidBottom
